import { render, staticRenderFns } from "./ASorItemMappingList.vue?vue&type=template&id=7875859d"
import script from "./ASorItemMappingList.vue?vue&type=script&lang=js"
export * from "./ASorItemMappingList.vue?vue&type=script&lang=js"
import style0 from "./ASorItemMappingList.vue?vue&type=style&index=0&id=7875859d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports